export class BusinessDetailsInput {
    id!: number;
    name!: string;
    language!: string;
    timeFormat?: string | null;
    timezone!: string;
    currency!: string;
    image!: string;
    /** Primary brand hex color (buttons, accents, gradient start). */
    brandColor?: string | null;
    /** Darker variant — hover states, gradient end. */
    brandColorStrong?: string | null;
    /** Lighter variant — soft backgrounds, selected/hover tints. */
    brandColorSoft?: string | null;
    /** Comma-separated PaymentMethod values. */
    acceptedPaymentMethods?: string | null;
    website!: string;
    address1!: string;
    address2!: string;
    city!: string;
    state!: string;
    country!: string;
    zipCode!: string;
    /** Exact coordinates of the picked address (autocomplete); optional. When the
     *  address changes without new coords, the backend clears them to re-geocode. */
    latitude?: number | null;
    longitude?: number | null;
    retailsSalesTaxRate!: number;
    discountAllowedRateDefault!: number;
    discountAllowedRate1!: number;
    discountAllowedRate2!: number;
    discountAllowedRate3!: number;
    discountAllowedRate4!: number;
    /* ---------- Public profile (marketplace) ---------- */
    coverImage?: string | null;
    category?: string | null;
    headline?: string | null;
    about?: string | null;
    yearsExperience?: number | null;
    highlight?: string | null;
    publicPhone?: string | null;
    instagram?: string | null;
    facebook?: string | null;
    onboardingComplete?: boolean | null;
}
